import { BAR_HEIGHT_INLINE, BAR_TRACK } from './barScale';

/**
 * The figure table's frame (spec 234 R5): Spend's Where it went measured it first
 * (spec 225), and the Models tab's Profiles ledger wears the same one, so the two AI
 * usage tabs draw a table one way. Header band, right-aligned tabular figures, a
 * thin bar under the figure it measures, a foot that adds the columns up.
 */

/** The table runs edge to edge under a `p-4` card's padding; its foot is the card's bottom. */
export const FIGURE_TABLE_BLEED = '-mx-4 -mb-4';

export const FIGURE_TABLE = 'w-full text-sm';

export const FIGURE_HEAD = 'bg-muted/40 text-muted-foreground text-xs';

/** The name column's header cell; the figures' are `FIGURE_HEAD_CELL`. */
export const FIGURE_HEAD_NAME = 'px-4 py-2 text-left font-medium';

export const FIGURE_HEAD_CELL = 'px-3 py-2 text-right font-medium';

/** One row's group: a rule above it, its lines under it. */
export const FIGURE_BODY = 'border-border border-t';

export const FIGURE_ROW = 'hover:bg-muted/40 transition-colors';

/** The name cell. */
export const FIGURE_NAME = 'px-4 py-3 text-left align-top font-normal';

/** A figure cell. */
export const FIGURE_CELL =
  'px-3 py-3 text-right align-top tabular-nums whitespace-nowrap';

/** The row's open/close control, before its marker. */
// `touch-hit`, not `touch-target`: the 44px reach is drawn around the 28px
// mark rather than widening it, which pushed a phone's name column 16px right
// (spec 277).
export const FIGURE_TOGGLE =
  'relative touch-hit text-muted-foreground hover:text-foreground hover:bg-muted focus-visible:ring-ring grid size-7 shrink-0 place-items-center rounded-md focus-visible:ring-3 focus-visible:outline-none';

/** The comparison, under the figure it measures: the inline bar of the bar scale. */
export const FIGURE_BAR_TRACK = `${BAR_TRACK} ${BAR_HEIGHT_INLINE} w-full max-w-28 overflow-hidden rounded-full`;

export const FIGURE_BAR = 'block h-full rounded-full bg-chart-1';

/** A line under a row draws its bar lighter, on the same scale. */
export const FIGURE_BAR_CHILD = 'block h-full rounded-full bg-chart-1/50';

export const FIGURE_FOOT = 'border-border bg-muted/40 border-t font-semibold';
